import { makeRequest } from 'utils/requestLogger';

export default (poll_id, selections) =>
  makeRequest('post', `/api/votes`, { poll_id, selections });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/votePoll.js